import { IStatusBarConfig } from './IStatusBarConfig';

export { IStatusBarConfig };
